import axios from 'axios';
import { API_BASE_URL } from '../../config';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const scheduleService = {
  getAll: () => {
    return api.get('/schedules');
  },
  
  getById: (id) => {
    return api.get(`/schedules/${id}`);
  },
  
  create: (schedule) => {
    return api.post('/schedules', schedule);
  },
  
  update: (id, schedule) => {
    return api.put(`/schedules/${id}`, schedule);
  },
  
  delete: (id) => {
    return api.delete(`/schedules/${id}`);
  },
  
  activate: (id) => {
    return api.post(`/schedules/${id}/activate`);
  },
  
  deactivate: (id) => {
    return api.post(`/schedules/${id}/deactivate`);
  }
};

export default scheduleService;
